export default __webpack_public_path__ + "static/media/wa-1719.ebaf9599.jpg";